import { Stack, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	label: string;
	value?: string;
	bold?: boolean;
	children?: ReactNode;
};

export const TaskKeyValueRow: FC<Props> = ({
	label,
	value,
	bold,
	children,
}) => (
	<Stack
		direction="row"
		justifyContent="space-between"
		alignItems="flex-start"
		px={1.6}
		py={0.6}
	>
		<Typography variant="body2" flexShrink={0} mr={1.6}>
			{label}
		</Typography>
		<Typography
			variant={bold ? "bodyStrong" : "body2"}
			color="text.primary"
			textAlign="right"
		>
			{children ?? value}
		</Typography>
	</Stack>
);
